import { render } from "./TheMenu.vue?vue&type=template&id=40153714&scoped=true"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=40153714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40153714"]])

export default __exports__